import React from 'react';
import HelpIcon from '@material-ui/icons/Help'
import IconButton from '@material-ui/core/IconButton'
import Popover from '@material-ui/core/Popover'
import PopupState, { bindTrigger, bindPopover } from 'material-ui-popup-state'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'


const useStyles = makeStyles((theme) => ({
    typography: {
        margin: theme.spacing(2),
    },
    icon: {
        paddingLeft: '15px',
        paddingTop: '10px',
        cursor: 'pointer',
        color: 'rgba(0, 0, 0, 0.54)',
    },
}));

export function PopoverComponent(props) {
    let classes = useStyles();
    let { text, ...other } = props;

    return (
        <PopupState variant="popover" popupId="demoPopover">
            {popupState => (
                <div>
                    <HelpIcon
                        {...bindTrigger(popupState)}
                        className={classes.icon}
                        color='inherit'
                        {...props.iconProps}
                    />
                    <Popover
                        {...bindPopover(popupState)}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                        transformOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center',
                        }}
                    >
                        <Typography variant='body2' className={classes.typography}>
                            {text}
                        </Typography>
                    </Popover>
                </div>
            )}
        </PopupState>
    )
};
